import React from 'react';
import classNames from 'classnames';
import { Button, ModalPortal, Alert, CopyToClickBoard } from '../../../../components';
import TimeLeft from './TimeLeft';
import css from './OfferInfoModal.css';
import Accordion from '../../common/Accordion';

const OfferInfoModal = ({
    redirectToLogin,
    isOpen,
    isLoggedOut,
    endDate,
    onClose,
    logo,
    voucherCode,
    teaserText,
    dialogAcc1,
    dialogText1,
    dialogAcc2,
    dialogText2,
    dialogAcc3,
    dialogText3,
    dialogAcc4,
    dialogText4,
    voucherType,
    logoClassName,
    queryParams = null,
}) => {
    const weblink =
        dialogAcc3 && dialogText3
            ? {
                  heading: <h3>{dialogAcc3}</h3>,
                  description: (
                      <a href={dialogText3} rel="nofollow" target="_blank">
                          {dialogText3
                              .replace('http://www', 'www.')
                              .replace('http://', 'www.')
                              .replace('https://', 'www.')}
                      </a>
                  ),
              }
            : {};

    const questions = [
        { h: dialogAcc1, d: dialogText1 },
        { h: dialogAcc2, d: dialogText2 },
        { h: dialogAcc4, d: dialogText4 },
    ]
        .filter(({ h, d }) => Boolean(h && d))
        .map(({ h, d }) => ({
            heading: <h3>{h}</h3>,
            description: <p>{d}</p>,
        }))
        .concat(weblink)
        .filter(({ heading, description }) => !!heading && description);

    const isLinkTypeVoucher = voucherType === 'link';
    const voucherCodeSidenote = isLinkTypeVoucher
        ? 'Du gelangst über den obigen Link direkt auf die Website der Marke, wo Du das Angebot nutzen kannst.'
        : 'Verwende den obigen Code beim Einkauf auf der Website der Marke, um das Angebot zu nutzen.';

    return (
        <ModalPortal
            id="super-deal-modal"
            containerClassName={css.modalContainer}
            contentClassName={css.modalContent}
            isOpen={isOpen}
            onClose={onClose}
            containerClassNameJoined
            isSticky
        >
            <div
                className={classNames(css.logo, {
                    [logoClassName]: !!logoClassName,
                })}
                style={{
                    backgroundImage: `url(${logo})`,
                }}
            />
            <TimeLeft endDate={endDate} />

            <h3 className={css.modalTitle}>{teaserText}</h3>
            {isLoggedOut ? (
                <Alert
                    header="Anmeldung erforderlich"
                    description="Melde dich an, um Zugriff auf Gutscheine und Rabatte deiner Lieblingsmarken zu erhalten."
                    showAsPlainText
                    closeAllowed={false}
                    rootClassName={css.alertRoot}
                />
            ) : (
                <div>
                    <CopyToClickBoard
                        isPlainLink={!!isLinkTypeVoucher}
                        actionString={voucherCode}
                        queryParams={queryParams}
                    />
                    <p className={css.voucherCodeSidenote}>{voucherCodeSidenote}</p>
                </div>
            )}

            <div className={css.separator} />

            <Accordion itemClassName={css.accordeonItem} questions={questions} avoidTags />

            <footer>
                {isLoggedOut ? (
                    <Button type="button" className={css.submitButton} onClick={redirectToLogin}>
                        Anmelden
                    </Button>
                ) : (
                    <Button type="button" className={css.submitButton} onClick={onClose}>
                        Schliessen
                    </Button>
                )}
            </footer>
        </ModalPortal>
    );
};

export default OfferInfoModal;
